import React, { useEffect } from 'react'
import useStyles from './styles'
import { toast } from 'react-toastify'
import axios from 'axios';
import Notification from "../../components/Notification/Notification";
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import FormHelperText from '@material-ui/core/FormHelperText'
import { Typography, Button } from '../../components/Wrappers/Wrappers'
import { withStyles } from '@material-ui/styles'
import {
    TextField,
    Grid,
    Box
} from "@material-ui/core";
import Widget from '../../components/Widget/Widget'
import {
    Checkbox,
    FormControlLabel,
    FormControl,
    FormLabel,
    Radio,
    RadioGroup,
} from "@material-ui/core";

const EditQuestion = () => {
    const classes = useStyles();
    const [questionId, setQuestionId] = React.useState("");
    const [questionGroupId, setQuestionGroupId] = React.useState("");
    const [ownAnswerTexts, setOwnAnswerTexts] = React.useState(["Ja", "Nej", "Ej aktuell"]);
    const [questionType, setQuestionType] = React.useState("question");
    const [headerText, setHeaderText] = React.useState("");

    const [question, setQuestion] = React.useState({
        text: "",
        description: "",
        answers: [],
        questionType: "",
        formQuestionGroupID: "",
        sortOrder: 0
    });

    useEffect(() => {
        const params = window.location.href.split('?')[1];

        if (params && params.length > 0) {
            const urlParams = new URLSearchParams(params);
            const newQuestionId = urlParams.get('frageID');
            const newQuestionGroupId = urlParams.get('checklistaID');
            setQuestionId(newQuestionId);
            setQuestionGroupId(newQuestionGroupId);

            axios.get('/FormQuestion/' + newQuestionId).then(
                res => {
                    if (res.data.questionType === "header") {
                        setHeaderText(res.data.text);
                        setQuestionType("header");
                    }

                    let newAnswers = [];

                    for (var i = 0; i < 3; i++) {
                        if (res.data.answers[i]) {
                            newAnswers.push(res.data.answers[i].text);
                        } else {
                            newAnswers.push("");
                        }
                    }

                    let newQuestion = {
                        text: res.data.text,
                        description: res.data.description,
                        answers: newAnswers,
                        questionType: res.data.questionType,
                        formQuestionGroupID: res.data.formQuestionGroupID,
                        sortOrder: res.data.sortOrder,
                        hideComment: res.data.hideComment
                    }

                    setQuestion(newQuestion);
                    setOwnAnswerTexts(newAnswers);
                }
            ).catch(err => {
                console.log('err');
                console.log(err);
            });
        }
    }, []);

    function handleChange(e) {
        setQuestion({
            ...question,
            [e.target.name]: e.target.value,
        });
    }

    function handleAnswerChange(e, answerNumber) {
        let newAnswers = [...ownAnswerTexts]
        newAnswers[answerNumber] = e.target.value;
        setOwnAnswerTexts(newAnswers);
    }

    const handleNext = () => {
        if (questionType === "header") {
            let newQuestion = {
                text: headerText,
                description: "Rubrik",
                sortOrder: 0,
                answers: [],
                hideComment: true,
                questionType: "header",
                formQuestionGroupID: questionGroupId
            }

            axios.put('/FormQuestion/update/' + questionId, newQuestion).then(res => {
                if (res.status === 200) {
                    sendNotification();
                    window.location.href = '/#/app/frågor/lista?checklistaID=' + questionGroupId;
                }
            }).catch(err => {
                console.log('err');
                console.log(err);
            })
        } else {
            let newQuestion = { ...question };
            newQuestion.answers = [];

            for (var i = 0; i < ownAnswerTexts.length; i++) {
                if (ownAnswerTexts[i]) {
                    newQuestion.answers.push({ id: i + 1, text: ownAnswerTexts[i] });
                }
            }

            axios.put('/FormQuestion/update/' + questionId, newQuestion).then(res => {
                if (res.status === 200) {
                    sendNotification();
                    window.location.href = '/#/app/frågor/lista?checklistaID=' + questionGroupId;
                }
            }).catch(err => {
                console.log('err');
                console.log(err);
            })
        }
    };

    function sendNotification() {
        const componentProps = {
            type: "feedback",
            message: "Fråga ändrad!",
            variant: "contained",
            color: "success"
        };

        const options = {
            type: "info",
            position: toast.POSITION.TOP_RIGHT,
            progressClassName: classes.progress,
            className: classes.notification,
            timeOut: 1000
        };

        return toast(
            <Notification
                {...componentProps}
                className={classes.notificationComponent}
            />,
            options
        );
    }

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Widget>
                    <Grid item justifyContent={'center'} container>
                        <Box
                            display={'flex'}
                            flexDirection={'column'}
                            width={600}
                        >
                            <Typography
                                variant={'h5'}
                                weight={'medium'}
                                style={{ marginBottom: 30 }}
                            >
                                Redigera fråga
                            </Typography>
                            <FormControl
                                variant="outlined"
                                onChange={handleChange}
                                style={{ marginBottom: 35 }}
                            >
                                <InputLabel>
                                    Fråga eller rubrik
                                </InputLabel>
                                <Select
                                    value={questionType}
                                    name="questionType"
                                    onChange={e => setQuestionType(e.target.value)}
                                    label="Fråga eller rubrik"
                                >
                                    <MenuItem value="question">Fråga</MenuItem>
                                    <MenuItem value="header">Rubrik</MenuItem>
                                </Select>
                                <FormHelperText>
                                    Ange om du vill ha en fråga eller rubrik
                                </FormHelperText>
                            </FormControl>

                            {questionType === "question" && <>
                                <TextField
                                    id="text"
                                    label="Fråga"
                                    onChange={handleChange}
                                    name="text"
                                    value={question.text}
                                    variant="outlined"
                                    style={{ marginBottom: 30 }}
                                    helperText="Skriv in själva frågan"
                                />
                                <TextField
                                    id="description"
                                    label="Beskrivning"
                                    onChange={handleChange}
                                    name="description"
                                    value={question.description}
                                    variant="outlined"
                                    style={{ marginBottom: 30 }}
                                    helperText="Ge en frivillig beskrivning som visas under själva frågan"
                                />

                                <Typography style={{ fontWeight: "bold" }}>Svarsalternativ</Typography>
                                <Typography style={{ fontSize: "0.85rem" }}>Lämna fält tomma för att ha färre svarsalternativ</Typography>

                                <TextField
                                    id="answer1"
                                    label="Alternativ 1"
                                    onChange={(e) => handleAnswerChange(e, 0)}
                                    name="answer1"
                                    value={ownAnswerTexts[0]}
                                    variant="outlined"
                                    style={{ marginBottom: 30, marginTop: 30 }}
                                    helperText="Skriv första svarsalternativet"
                                />
                                <TextField
                                    id="answer2"
                                    label="Alternativ 2"
                                    onChange={(e) => handleAnswerChange(e, 1)}
                                    name="answer2"
                                    value={ownAnswerTexts[1]}
                                    variant="outlined"
                                    style={{ marginBottom: 30 }}
                                    helperText="Skriv andra svarsalternativet"
                                />
                                <TextField
                                    id="answer3"
                                    label="Alternativ 3"
                                    onChange={(e) => handleAnswerChange(e, 2)}
                                    name="answer3"
                                    value={ownAnswerTexts[2]}
                                    variant="outlined"
                                    style={{ marginBottom: 30 }}
                                    helperText="Skriv tredje svarsalternativet"
                                />
                            </>}

                            {questionType === "header" && <>
                                <TextField
                                    id="text"
                                    label="Rubriktext"
                                    onChange={e => setHeaderText(e.target.value)}
                                    name="text"
                                    value={headerText}
                                    variant="outlined"
                                    style={{ marginBottom: 30 }}
                                    helperText="Skriv in vad som ska stå som rubrik"
                                />
                            </>}

                            <div>
                                <Box
                                    display={'flex'}
                                    justifyContent={'flex-end'}
                                >
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleNext}
                                        disabled={question.text.length === 0}
                                    >
                                        Spara ändringar
                                    </Button>
                                </Box>
                            </div>
                        </Box>
                    </Grid>
                </Widget>
            </Grid >
        </Grid >
    )
}

export default EditQuestion
